// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'

import BootstrapVue from 'bootstrap-vue' // if need BootstrapVue
import 'izitoast/dist/css/iziToast.min.css'

import router from './router'
import store from './store'

import endpoints from 'api/endpoints'
import api from 'api'
import helper from '@/assets/js/helper'
import i18n from './i18n/i18n'
import {
    orderStatus
} from '@/utils'

import VueMeta from 'vue-meta'
import VeeValidate from 'vee-validate'
import vSelect from 'vue-select'
import * as VueGoogleMaps from 'vue2-google-maps'

import App from './App'
import HeaderNav from '~cp/HeaderNav.vue'
import FooterComponent from '~cp/FooterComponent.vue'
import BtnBack from '~cp/UserPanel/Elements/BtnBack'

import 'style/main.scss'
Vue.use(BootstrapVue)
Vue.use(VueMeta, {keyName: 'metaInfo', refreshOnceOnNavigation: true})
Vue.use(VeeValidate, {fieldsBagName: 'formFields'})

Vue.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyDL-FYLre99VOHA9Np4LKoFCxcPupf-DxM',
        libraries: 'places'
    }
})

Vue.component('v-select', vSelect)
Vue.component('header-nav', HeaderNav)
Vue.component('footer-component', FooterComponent)
Vue.component('btn-back', BtnBack)

Vue.filter('orderStatusFormat', orderStatus)

// Added custom prototype to instance of the Vue
Vue.prototype.$endpoints = endpoints
Vue.prototype.$api = api
Vue.prototype.$helper = helper

Vue.config.productionTip = false


new Vue({
    el: '#app',
    router,
    store,
    i18n,
    components: {App},
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js